import PropTypes from 'prop-types'
import React from 'react'
import { TagBox } from '../../molecules/TagBox'
import { Button } from '../../atoms/Button'
import useUser, { urlFetch } from '../../../hooks/useUser'
import useMutation from '../../../hooks/useMutation'
import { urlToJson } from '../../../utils/helpers'
import { isPresentInGobPe } from '../../../configs/usersConfig'

const enabledText = {
  true: { label: 'Activo', tagType: 'success', changeText: 'Inactivar' },
  false: { label: 'Inactivo', tagType: 'neutral', changeText: 'Activar' }
}

const UserStatus = ({ user }) => {
  const status = enabledText[user.enabled]
  const { updateEnabledUser, invalidateUsers } = useUser()
  const { mutate: handleEnabledChange } = useMutation(updateEnabledUser(user.id, !user.enabled), {
    onSuccess: () => {
      invalidateUsers(urlToJson(urlFetch))
    }
  })

  return (
    <div className="flex flex-col items-start gap-1">
      <TagBox className="text-xs" label={status.label} tagType={status.tagType} />
      {isPresentInGobPe(user) && (
        <Button
          variant="text"
          className="text-xs w-fit text-left px-0"
          spaceSize="small"
          size="full"
          onClick={handleEnabledChange}
        >
          {status.changeText}
        </Button>
      )}
    </div>
  )
}

export default UserStatus

UserStatus.propTypes = {
  user: PropTypes.object
}
